import { FC } from 'react';

import { useFormContext } from 'react-hook-form';

import RhfRadioGroup from 'components/RadioGroup/RhfRadioGroup/RhfRadioGroup';
import {
  MIDLINE_IMPROVE,
  MIDLINE_IMPROVE_ADJUST_PATIENT,
  MIDLINE_IMPROVE_VALUES
} from 'constants/prescriptionOptions';

interface Props {
  isDisabled?: boolean;
}
const ImproveMidline: FC<Props> = ({ isDisabled }) => {
  const { watch } = useFormContext();
  const watchImproveMidlineUpper = watch(
    'treatmentSpecifications.ZenClearUltra.midline.ImproveMidline.Upper.upper'
  );
  const watchImproveMidlineLower = watch(
    'treatmentSpecifications.ZenClearUltra.midline.ImproveMidline.Lower.lower'
  );
  return (
    <div>
      <div className='flex flex-col'>
        <div className=' flex flex-row space-x-4 mb-2 '>
          <div className='mt-3 bg-black text-white flex justify-center items-center  w-6 h-6 rounded-full'>
            <span>U</span>
          </div>
          <div>
            <RhfRadioGroup
              inputProps={{ disabled: isDisabled }}
              options={MIDLINE_IMPROVE}
              name='treatmentSpecifications.ZenClearUltra.midline.ImproveMidline.Upper.upper'
              className='flex flex-row space-x-16'
              radioClassName='border-RADIO_BORDER'
              radioItemFont='md:text-17px text-sm '
            />
          </div>
        </div>
        {(watchImproveMidlineUpper ===
          MIDLINE_IMPROVE_VALUES.ADJUST_PATIENT_LEFT ||
          watchImproveMidlineUpper ===
            MIDLINE_IMPROVE_VALUES.ADJUST_PATIENT_RIGHT) && (
          <div className='ml-10 bg-CHINESE_WHITE p-4 rounded-2xl my-2 '>
            <RhfRadioGroup
              inputProps={{ disabled: isDisabled }}
              options={MIDLINE_IMPROVE_ADJUST_PATIENT}
              name='treatmentSpecifications.ZenClearUltra.midline.ImproveMidline.Upper.adjustPatient'
              className=' flex flex-row space-x-16'
              radioClassName='border-RADIO_BORDER'
              radioItemFont='md:text-17px text-sm '
            />
          </div>
        )}
      </div>
      <div className='flex flex-col'>
        <div className=' flex flex-row space-x-4 mb-2 '>
          <div className='mt-3 bg-black text-white flex justify-center items-center  w-6 h-6 rounded-full'>
            <span>L</span>
          </div>
          <div>
            <RhfRadioGroup
              inputProps={{ disabled: isDisabled }}
              options={MIDLINE_IMPROVE}
              name='treatmentSpecifications.ZenClearUltra.midline.ImproveMidline.Lower.lower'
              className='flex flex-row space-x-16'
              radioClassName='border-RADIO_BORDER'
              radioItemFont='md:text-17px text-sm '
            />
          </div>
        </div>
        {(watchImproveMidlineLower ===
          MIDLINE_IMPROVE_VALUES.ADJUST_PATIENT_LEFT ||
          watchImproveMidlineLower ===
            MIDLINE_IMPROVE_VALUES.ADJUST_PATIENT_RIGHT) && (
          <div className='ml-10 bg-CHINESE_WHITE p-4 rounded-2xl my-2 '>
            <RhfRadioGroup
              inputProps={{ disabled: isDisabled }}
              options={MIDLINE_IMPROVE_ADJUST_PATIENT}
              name='treatmentSpecifications.ZenClearUltra.midline.ImproveMidline.Lower.adjustPatient'
              className=' flex flex-row space-x-16'
              radioClassName='border-RADIO_BORDER'
              radioItemFont='md:text-17px text-sm '
            />
          </div>
        )}
      </div>
    </div>
  );
};
export default ImproveMidline;
